
// This file contains all GraphQL subscription operation strings for Amplify v6.
// These are used by the useGraphqlSubscription abstraction hook.

export const onCreateOperationalEntityV2 = /* GraphQL */ `
  subscription OnCreateOperationalEntityV2($transactionId: String) {
    result: onCreateOperationalEntityV2(transactionId: $transactionId) {
      transactionId
      id
      sources {
        sourceId
        sourceType
      }
      dbaName
      status
      message
    }
  }
`;
